import { noddiAsync } from 'noddi-async';
import { brandLabels, type BrandType } from 'noddi-types';
import { tracking } from 'noddi-web';

const BRAND_ANALYTICS_TYPES = ['brand'] as const;

/** Mirror the active brand onto OpenPanel/Mixpanel and the API brand header. */
export function syncBrandAnalytics(brand: BrandType) {
  tracking.registerBoot({ brand });
  tracking.setGroups([{ type: 'brand', id: brand, name: brandLabels[brand] }], {
    types: BRAND_ANALYTICS_TYPES,
    boot: true
  });
  noddiAsync.setHeader('X-Navio-Brand', brand);
}
